// extracted by mini-css-extract-plugin
export default {"search":"SearchField_search__7MPxu","subtitle":"SearchField_subtitle__JE83D"};